import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IndustrialCodeTypes, PrimaryFunctions } from '@xbs/xbs-enums';

import {
  ClosableModalWithErrorResponseModel
} from '../../../../../shared/components/base/closable-modal-with-error-response-model';

import { NotificationService, PbasService } from '../../../../../shared/services';
import { ModalService } from '../../../../../shared/modules/modal';
import {
  CharacterizeTestedPartyModalPayload,
  TypeOfPrimaryFunctionOption,
  CharacterizeTestedPartyCodes,
  Characterization,
  CharacterizeTestedPartyOptionTypeErrorResponse,
  IndustrialCodeType,
  IndustrialCodeValue
} from '../../../../../shared/models';

@Component({
  selector: 'provide-codes-modal',
  templateUrl: './provide-codes-modal.component.html',
})
export class ProvideCodesModalComponent
  extends ClosableModalWithErrorResponseModel<CharacterizeTestedPartyOptionTypeErrorResponse> implements OnInit {
  data: CharacterizeTestedPartyModalPayload;
  characterization: Characterization;
  typeOfOptions: TypeOfPrimaryFunctionOption[] = [];
  industryTypeOptions: IndustrialCodeType[] = [];
  industryValueOptions: IndustrialCodeValue[] = [];
  selectedTypeOfOptions = null;
  selectedIndustryTypeOptions = null;
  selectedIndustryValueOptions = null;
  codes = new CharacterizeTestedPartyCodes();
  wholesalerId = 2; // TODO remove once we allow multiple types again
  temporaryHiddenIndustrialCodeTypes: string[] = [IndustrialCodeTypes.Types.Naics];

  constructor(
    protected modalService: ModalService,
    protected notificationService: NotificationService,
    private _pbasService: PbasService,
    private _translateService: TranslateService
  ) {
    super(notificationService, modalService);
    this.validationErrors = new CharacterizeTestedPartyOptionTypeErrorResponse();
  }

  ngOnInit(): void {
    this.listenForErrorMessages();
    this.characterization = this.data.characterization;
    this.getTypeOfOptions();
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    if (this.characterization.characterizationId) {
      this.updateCodeOptions();
      return;
    }
    this.createCodeOptions();
  }

  updateIndustryTypeOptions(typeOfPrimaryFunctionOptionId: number): void {
    this.selectedIndustryTypeOptions = null;
    this.selectedIndustryValueOptions = null;
    this.codes.codeType = null;
    this.codes.industrialCodeValue = null;
    this.industryValueOptions = [];

    const type = this.typeOfOptions.find(typeOfOption => typeOfOption.typeOfPrimaryFunctionOptionId === typeOfPrimaryFunctionOptionId);
    this.codes.typeOfPrimaryFunctionOption = type;
    this.industryTypeOptions = type.codeTypes.filter(codeType => !this.temporaryHiddenIndustrialCodeTypes.includes(codeType.name));
  }

  updateIndustryValueOptions(industrialCodeTypeId: number): void {
    this.selectedIndustryValueOptions = null;
    this.codes.industrialCodeValue = null;

    const type = this.industryTypeOptions.find(industryTypeOption => industryTypeOption.codeTypeId === industrialCodeTypeId);
    this.codes.codeType = type;
    this.industryValueOptions = type.subtypes;
    this.industryValueOptions.forEach(option => {
      option.displayLabel = `${option.value} - ${this._translateService.instant(option.name)}`;
    });
  }

  setIndustryValue(industryValueId: number): void {
    const type = this.industryValueOptions.find(industryValueOption => industryValueOption.industrialCodeValueId === industryValueId);
    this.codes.industrialCodeValue = type;
  }

  private getTypeOfOptions(): void {
    const primaryFunctionId = PrimaryFunctions.ByType.Distributor.includes(this.data.testedParty.primaryFunction.primaryFunctionId) ? PrimaryFunctions.ByName.Distributor.Id : PrimaryFunctions.ByName.ServiceProvider.Id;
    this._pbasService
      .getTypeOfOptions(primaryFunctionId)
      .subscribe(({ data }) => {
        this.typeOfOptions = data;
        // if characterization already exist populate the form with the values
        if (this.characterization.characterizationId && this.characterization.typeOfPrimaryFunctionOption) {
          this.selectedTypeOfOptions = this.characterization.typeOfPrimaryFunctionOption.typeOfPrimaryFunctionOptionId;
          this.updateIndustryTypeOptions(this.selectedTypeOfOptions);
          this.selectedIndustryTypeOptions = this.characterization.codeType.codeTypeId;
          this.updateIndustryValueOptions(this.selectedIndustryTypeOptions);
          this.selectedIndustryValueOptions = this.characterization.industrialCodeValue.industrialCodeValueId;
          this.setIndustryValue(this.selectedIndustryValueOptions);
        } else {
          /*
            TODO remove entire 'else' when inputting type is returned,
            right now as requested just temporarily we removed the option for type to be anything other than wholesaler
          */
          this.characterization.typeOfPrimaryFunctionOption = new TypeOfPrimaryFunctionOption();
          this.characterization.typeOfPrimaryFunctionOption.typeOfPrimaryFunctionOptionId = this.wholesalerId;
          this.selectedTypeOfOptions = this.characterization.typeOfPrimaryFunctionOption.typeOfPrimaryFunctionOptionId;
          this.updateIndustryTypeOptions(this.selectedTypeOfOptions);
        }
      });
  }

  private createCodeOptions(): void {
    this._pbasService
      .saveTestedPartyCharacterizationOptionType(
        this.data.testedParty.pba.pbaId,
        this.codes
      )
      .subscribe(() => {
        this.success();
        this.close();
      });
  }

  private updateCodeOptions(): void {
    this._pbasService
      .updateTestedPartyCharacterizationOptionType(
        this.data.testedParty.pba.pbaId,
        this.codes
      )
      .subscribe(() => {
        this.success();
        this.close();
      });
  }
}
